export const visit = "Visit"
export const cleaning = "Cleaning"
export const NewUser = "New User? Please register yourself"
export const Visitors = "What type of visitors is the most frequent in our stores?"
export const Mandatory  = "indicates mandatory field"
export const FirstName = "First Name"
export const LastName  = "Last Name"
export const UserName  = "User Name"
export const Domain  = "Domain Name"
export const Password  = "Password"
export const RetypePassword  = "Retype Password"
export const Submit  = "Submit"
export const Cancel  = "Cancel"
export const emptyFirstName = "First name cannot be empty"
export const emptyLastName  = "Last name cannot be empty"
export const emptyVendorName  = "Please select domain"
export const emptyUserName  = "User name cannot be empty"
export const emptyPassword = "Please Enter Password"
export const emptyRePassword  = "Please Enter Password again"
export const emptyPasswordMismatch = "Passwords do not match"
export const emptyPasswordPolicy = "Please follow the Password Policy"
export const PasswordPolicy1 = "Password hints : 8 characters or longer."
export const PasswordPolicy2 = "At least one number or symbol (likeA-Z,a-z,0-9,!$*@?\"#)"
export const Success  = "Success"
export const Authentication  = "For authentication an email has been sent to your registered address with a 6 digit passcode"
export const ThankYou = "Thank You."
export const Registered = "You have successfully registered."
export const UserExists = "User already exists"
export const EnterOTP  = "Enter Passcode"
export const emptyInvalidPasscode = "Invalid Passcode"
export const emptyOTP = "Please Enter Passcode"
export const TokenExpire = "Token Expired."